import React from "react";
import { Card } from "../../card";
import { BlockField } from "../";
export var BlockCard = function (_a) {
    var children = _a.children, queryVariables = _a.queryVariables;
    return (React.createElement(Card, null, children.map(function (block) { return (React.createElement(BlockField, { key: block.id, block: block, queryVariables: queryVariables })); })));
};
